import React from 'react';
import { Button, Stack } from '@mui/material';
import { BreadcrumbBar } from 'customer_portal-ui-shared';
import { OfficeList } from '../../component';

const Admin = () => {
    return (
        <>
            <Stack direction={'column'} spacing={2}>
                <BreadcrumbBar
                    pageName="Admin : Manage Offices"
                    parentPages={[
                        {
                            name: 'Office Map',
                            link: '/'
                        }
                    ]}
                />
                <OfficeList />
            </Stack>
        </>
    );
};

export default Admin;
